import styled, { css } from 'styled-components';

export const variantStyles = {
  primary: css`
    background-color: ${props => props.theme.colors.brand.primary};
    color: #fff;
    border: 2px solid ${props => props.theme.colors.brand.primary};

    &:hover:not(:disabled) {
      background-color: #0d4b96;
      border-color: #0d4b96;
    }
    
    &:active:not(:disabled) {
      background-color: ${props => props.theme.colors.brand.primary};
      border-color: ${props => props.theme.colors.brand.primary};
    }

    &:disabled {
      background-color: ${props => props.theme.colors.text.muted};
      border-color: ${props => props.theme.colors.text.muted};
      color: #fff;
    }
  `,
  secondary: css`
    background-color: transparent;
    color: ${props => props.theme.colors.brand.secondary};
    border: 2px solid ${props => props.theme.colors.brand.secondary};

    &:hover:not(:disabled) {
      background-color: rgba(0, 169, 255, 0.05);
      color: #007bbd;
      border-color: #007bbd;
    }

    &:active:not(:disabled) {
      background-color: rgba(0, 169, 255, 0.1);
      border-color: ${props => props.theme.colors.brand.secondary};
    }

    &:disabled {
      background-color: transparent;
      border-color: ${props => props.theme.colors.text.muted};
      color: ${props => props.theme.colors.text.muted};
    }
  `,
  tertiary: css`
    background-color: transparent;
    color: ${props => props.theme.colors.brand.primary};
    border: 2px solid transparent;
    text-transform: none;
    font-weight: 600;

    &:hover:not(:disabled) {
      color: ${props => props.theme.colors.brand.secondary};
      background-color: rgba(0, 169, 255, 0.05);
    }

    &:active:not(:disabled) {
      color: ${props => props.theme.colors.brand.primary};
    }

    &:disabled {
      color: ${props => props.theme.colors.text.muted};
    }
  `,
  negative: css`
    background-color: transparent;
    color: ${props => props.theme.colors.brand.primary};
    border: 2px solid transparent;
    text-transform: none;
    font-weight: 600;

    &:hover:not(:disabled) {
      color: ${props => props.theme.colors.brand.secondary};
    }

    &:active:not(:disabled) {
      color: ${props => props.theme.colors.brand.primary};
    }

    &:disabled {
      color: ${props => props.theme.colors.text.muted};
    }
  `,
  success: css`
    background-color: ${props => props.theme.colors.feedback.success};
    color: #fff;
    border: 2px solid ${props => props.theme.colors.feedback.success};

    &:hover:not(:disabled) {
      filter: brightness(0.9);
    }
    
    &:active:not(:disabled) {
      filter: brightness(0.8);
    }

    &:disabled {
      background-color: ${props => props.theme.colors.text.muted};
      border-color: ${props => props.theme.colors.text.muted};
      color: #fff;
    }
  `,
  warning: css`
    background-color: ${props => props.theme.colors.feedback.warning};
    color: #000;
    border: 2px solid ${props => props.theme.colors.feedback.warning};

    &:hover:not(:disabled) {
      filter: brightness(0.9);
    }
    
    &:active:not(:disabled) {
      filter: brightness(0.8);
    }

    &:disabled {
      background-color: ${props => props.theme.colors.text.muted};
      border-color: ${props => props.theme.colors.text.muted};
      color: #fff;
    }
  `,
  danger: css`
    background-color: ${props => props.theme.colors.feedback.error};
    color: #fff;
    border: 2px solid ${props => props.theme.colors.feedback.error};

    &:hover:not(:disabled) {
      filter: brightness(0.9);
    }
    
    &:active:not(:disabled) {
      filter: brightness(0.8);
    }

    &:disabled {
      background-color: ${props => props.theme.colors.text.muted};
      border-color: ${props => props.theme.colors.text.muted};
      color: #fff;
    }
  `,
  info: css`
    background-color: ${props => props.theme.colors.feedback.info};
    color: #fff;
    border: 2px solid ${props => props.theme.colors.feedback.info};

    &:hover:not(:disabled) {
      filter: brightness(0.9);
    }
    
    &:active:not(:disabled) {
      filter: brightness(0.8);
    }

    &:disabled {
      background-color: ${props => props.theme.colors.text.muted};
      border-color: ${props => props.theme.colors.text.muted};
      color: #fff;
    }
  `,
  light: css`
    background-color: #ffffff;
    color: ${props => props.theme.colors.text.primary};
    border: 1px solid ${props => props.theme.colors.text.muted};

    &:hover:not(:disabled) {
      background-color: ${props => props.theme.colors.surface.background};
    }
    
    &:active:not(:disabled) {
      background-color: ${props => props.theme.colors.text.muted};
    }

    &:disabled {
      background-color: #f9f9f9;
      color: ${props => props.theme.colors.text.muted};
      border-color: ${props => props.theme.colors.surface.background};
    }
  `,
  dark: css`
    background-color: ${props => props.theme.colors.text.primary};
    color: #fff;
    border: 1px solid ${props => props.theme.colors.text.primary};

    &:hover:not(:disabled) {
      filter: brightness(1.2);
    }
    
    &:active:not(:disabled) {
      filter: brightness(0.8);
    }

    &:disabled {
      background-color: ${props => props.theme.colors.text.muted};
      border-color: ${props => props.theme.colors.text.muted};
      color: #fff;
    }
  `,
  text: css`
    background-color: transparent;
    color: ${props => props.theme.colors.brand.primary};
    border: 2px solid transparent;

    &:hover:not(:disabled) {
      background-color: rgba(0, 0, 0, 0.05);
    }
    
    &:active:not(:disabled) {
      background-color: rgba(0, 0, 0, 0.1);
    }

    &:disabled {
      color: ${props => props.theme.colors.text.muted};
      background-color: transparent;
    }
  `,
};

export const sizeStyles = {
  xs: css`padding: ${props => props.theme.spacing.xs} ${props => props.theme.spacing.sm}; font-size: ${props => props.theme.typography.fontSize.xs};`,
  sm: css`padding: calc(${props => props.theme.spacing.xs} * 1.5) calc(${props => props.theme.spacing.sm} * 1.5); font-size: ${props => props.theme.typography.fontSize.sm};`,
  md: css`padding: ${props => props.theme.spacing.sm} ${props => props.theme.spacing.md}; font-size: ${props => props.theme.typography.fontSize.md};`,
  lg: css`padding: ${props => props.theme.spacing.md} ${props => props.theme.spacing.lg}; font-size: ${props => props.theme.typography.fontSize.lg};`,
};

export const shapeStyles = {
  rectangle: css`border-radius: 4px;`,
  rounded: css`border-radius: 50px;`,
};

export const StyledButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  font-weight: bold;
  font-family: ${props => props.theme.typography.fontFamily.base};
  gap: 8px;
  
  ${(props) => sizeStyles[props.size] || sizeStyles.md}
  ${(props) => shapeStyles[props.shape] || shapeStyles.rectangle}
  ${(props) => variantStyles[props.variant] || variantStyles.primary}

  ${(props) => props.iconButton && css`
    padding: ${(props.theme.spacing && props.theme.spacing.sm) || '8px'};
    border-radius: 50%;
  `}

  ${(props) => props.loading && css`
    cursor: wait;
    opacity: 0.8;
  `}

  &:focus { outline: none; box-shadow: 0 0 0 2px ${props => props.theme.colors.brand.secondary}55; }
  &:disabled { cursor: not-allowed; opacity: 1; }
`;



// WEBPACK FOOTER //
// ./src/design-system/atoms/Button/components/ButtonStyles.js